import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2 } from "lucide-react";
import { getVzRankSettings } from "@/lib/verizonSalesApi";
import { SourceSelect } from "./LeaderboardSettingsPanel";

const slugKey = (label) => `custom_${label.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "").slice(0, 40)}`;

export const customCat = (key, rule) => ({ key, label: rule.custom.label, kind: rule.custom.kind, pctBase: "Verizon Current Quota", custom: true });

// Form to add a KPI that isn't a dashboard card yet (e.g. a new Verizon column) so it can be used in Overall Rank.
export const AddCustomKpi = ({ settings, onAdd }) => {
  const [options, setOptions] = useState(null);
  const [label, setLabel] = useState("");
  const [kind, setKind] = useState("count");
  const [source, setSource] = useState({ type: "raw", column: "" });
  useEffect(() => { getVzRankSettings().then((d) => setOptions(d.options)).catch(() => {}); }, []);
  if (!options) return null;
  const key = slugKey(label);
  const ok = key !== "custom_" && (source.key || source.column) && !settings[key];
  const add = () => {
    onAdd(key, { mode: kind === "rate" ? "percent" : "number", value: kind === "rate" ? 50 : 1, overrides: {}, custom: { label: label.trim(), kind, source } });
    setLabel(""); setSource({ type: "raw", column: "" });
  };
  return (
    <div className="pt-4 mt-2 border-t border-slate-200" data-testid="vz-quota-custom-add">
      <p className="text-sm font-medium text-navy mb-2">Add a custom KPI</p>
      <div className="flex items-center gap-2 flex-wrap">
        <Input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="KPI name, e.g. Ports" className="h-9 w-44" data-testid="vz-quota-custom-label" />
        <SourceSelect value={source} options={options} onChange={(s) => { setSource(s); if (s.type === "ratio" || /%/.test(s.column || "")) setKind("rate"); }} testId="vz-quota-custom-source" />
        <select value={kind} onChange={(e) => setKind(e.target.value)} className="h-9 rounded-md border border-slate-200 bg-white px-2 text-sm" data-testid="vz-quota-custom-kind">
          <option value="count">Count (number)</option><option value="rate">Percentage</option>
        </select>
        <Button size="sm" variant="outline" disabled={!ok} onClick={add} data-testid="vz-quota-custom-add-btn"><Plus className="w-4 h-4 mr-1" /> Add KPI</Button>
      </div>
      <p className="text-xs text-slate-400 mt-1">Then set its goal below and click Save quotas. It can then be picked in Overall Rank Settings.</p>
    </div>
  );
};

export const RemoveCustomBtn = ({ k, onRemove }) => (
  <Button variant="ghost" size="sm" onClick={() => onRemove(k)} data-testid={`vz-quota-${k}-delete`}><Trash2 className="w-4 h-4 mr-1 text-red-500" /> Remove KPI</Button>
);
